import React, { useEffect } from "react";
import { formattedPrice } from "../../utils";
import { useDispatch } from "react-redux";
import { fetchCartRemove } from "../../actions/global";
import { isDiscountActive } from "../../utils/disocount";
import { useTranslation } from "react-i18next";
import JwPlayer from "./JwPlayer";

const CartItem = (props) => {
  const { item } = props || {};
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleCartRemove = (item) => {
    dispatch(fetchCartRemove(item?.id));
  };

  const showDiscount = isDiscountActive(item);

  return (
    <div className="cart-modal-table-item">
      <div className="cart-modal-table-header">
        <div className="cart-modal-title-1"></div>
        <div className="cart-modal-title-2">{t("cart.price")}</div>
      </div>
      <div className="cart-modal-table-content">
        <div className="cart-modal-table-image">
          <JwPlayer
            videoId={item?.trailerTargetId}
            height="100%"
            aspectratio="16:9"
            sectionType={item?.sectionType}
          />
        </div>
        <div className="cart-modal-table-text">
          <div className="cart-modal-table-title">{item?.name}</div>
          {/* <div className="cart-modal-table-desc">{item?.description}</div> */}
        </div>
        <div className="cart-modal-table-price">
          {showDiscount ? (
            <>
              <div className="cart-modal-table-value discount-active">
                {formattedPrice(item?.discountPrice)} RSD
              </div>
              <div className="cart-modal-table-old-price">
                <s>{formattedPrice(item?.price)} RSD</s>
              </div>
            </>
          ) : (
            <div className="cart-modal-table-value">
              {formattedPrice(item?.price)} RSD
            </div>
          )}
          <div className="cart-modal-table-remove">
            <img
              src="/images/trash.png"
              alt=""
              className="img-fluid"
              onClick={() => handleCartRemove(item)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
